

import React from 'react';

const ProcessSection: React.FC = () => {
  const steps = [
    {
      number: '1',
      title: 'お申し込み',
      description: 'お電話またはWebフォームからお申し込み。受講日程を調整いたします。',
    },
    {
      number: '2',
      title: '座学講習',
      description: '航空法、農薬知識、機体知識など必要な知識を学習します。',
    },
    {
      number: '3',
      title: '実技講習',
      description: '実機を使用した飛行訓練、散布訓練を実施します。',
    },
    {
      number: '4',
      title: '資格取得',
      description: '筆記・実技試験合格後、技能認定証を発行いたします。',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">講習内容</h2>
          <p className="text-xl sm:text-lg text-gray-600">座学と実技で確実に技術を習得</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg h-full min-h-[400px]">
            <div className="w-16 h-16 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6">
              <i className="ri-book-open-line text-3xl text-[#76B947]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2A6041] mb-6">座学で学ぶこと</h3>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start">
                <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                <span>第1章：運用管理（航空法・関連法律）</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                <span>第2章：散布飛行知識（機体・散布方法）</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                <span>第4章：農薬知識</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                <span>第5章：作物保護知識</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                <span>第6章：自動航行（自動散布）</span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg h-full min-h-[400px]">
            <div className="w-16 h-16 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6">
              <i className="ri-flight-takeoff-line text-3xl text-[#76B947]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2A6041] mb-6">実技で習得すること</h3>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start">
                <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                <span>第3章：散布飛行練習（基本操作）</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                <span>危険物輸送訓練</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                <span>物件投下訓練</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                <span>第7章：自動航行練習</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                <span>筆記試験・実技試験</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">資格取得までの流れ</h2>
          <p className="text-xl sm:text-lg text-gray-600">お申し込みから資格取得まで</p>
        </div>

        <div className="grid md:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="bg-white rounded-xl p-6 shadow-lg h-full min-h-[180px] flex flex-col">
                <div className="w-16 h-16 bg-[#76B947] rounded-full flex items-center justify-center mb-4 mx-auto">
                  <span className="text-xl font-bold text-white">{step.number}</span>
                </div>
                <h3 className="text-lg font-bold text-[#2A6041] mb-3">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed flex-1">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;

